import React, { useCallback, useEffect, useState } from 'react'
import APIService from '../../Services/API/APIService'
import { Table, Dimmer, Loader, Button, Label, Modal } from 'semantic-ui-react'
import Checkout from '../Checkout/Checkout'
import dayjs from 'dayjs'
import numeral from 'numeral'
import { toast } from "react-toastify";

const CheckOutDetails = (props) => {

    const [loading, setLoading] = useState(false)
    const [checkoutModalState, toggleCheckoutModal] = useState(false)
    const [order, setOrder] = useState([])
    const [checkedCart, setCheckedCart] = useState(false)

    let totalAmount = []

    const fetchData = useCallback(async (isSubscribed) => {
        try {
            setLoading(true)
            if(isSubscribed){
            let result = await APIService.getData('/guest-house/getCheckoutDetails', {
                GuestHouseUserId: props.booking.GuestHouseUserId,
                GuestHouseBookingId: props.booking.id,

            })
                setOrder(result)
                setCheckedCart(true)
            }
            setLoading(false)
        } catch (error) {
            console.log(error);
            setLoading(false)
        }
    },[props.booking.GuestHouseUserId, props.booking.id])

    useEffect(() => {
        let isSubscribed = true
        fetchData(isSubscribed)
        return () => (isSubscribed = false)
    }, [fetchData])

    const checkoutCustomer = async () => {
        try {
            setLoading(true);
            let response = await APIService.postData(
                `/guest-house/checkout`,
                {
                    bookingId: props.booking.id,
                    bookingCode: props.booking.bookingId,
                    email: props.booking.GuestHouseUser.email,
                    firstname: props.booking.GuestHouseUser.firstname,
                    GuestHousePaymentId: props.booking.GuestHousePaymentId
                }
            );
            if (response) {
                props.toggleOrderModal(false)
                setLoading(false)
                toast.success("CheckedOut Successful")
            }


        } catch (error) {
             toast.warn(error)
            setLoading(false);
        }
    };

    const closeModal = (state) => {
        props.toggleOrderModal(state)
        setLoading(false)
        toast.success("CheckedOut Successful")

    }
    const makePayment = async () => {
        try {
            if (checkedCart === false) {
                await fetchData(true)
                return null
            }
            let payload = {
                firstname: props.booking?.GuestHouseSecretUser?.firstname || props.booking?.GuestHouseUser?.firstname,
                lastname: props.booking?.GuestHouseSecretUser?.lastname || props.booking?.GuestHouseUser?.lastname,
                email: props.booking?.GuestHouseUser?.email,
                phone: props.booking?.GuestHouseSecretUser?.phoneNumber || props.booking?.GuestHouseUser?.phoneNumber,
                checkin: props.booking?.checkin,
                checkout: props.booking?.checkout,
                nights: props.booking?.nights,
                roomName: props.booking?.GuestHousePackage?.name,
                price: props.booking?.GuestHousePackage?.price

            }
            localStorage.setItem('cartId', props.booking?.GuestHousePayment?.cartId)
            localStorage.setItem('payload', JSON.stringify(payload))
            toggleCheckoutModal(true)

        } catch (error) {
            toast.warn(error)
            setLoading(false);

        }
    };

   // const roomLength = order.filter((a) => a.name == 'Room').length
   // let sum = 0

    const orderItems = order?.map((item) => (
        <>
            <Table.Row key={item.id}>

                <Table.Cell>  {totalAmount.push(item.price)}</Table.Cell>

                <Table.Cell>{item?.name}</Table.Cell>
                <Table.Cell>
                    ₦{numeral(item?.price).format("0,0")}

                </Table.Cell>
                <Table.Cell>
                    
                    ₦ {item?.name === 'Room'? numeral(item?.discount).format("0,0") : 0}

                </Table.Cell>

                <Table.Cell>{dayjs(item.date).format("DD-MM-YYYY")}</Table.Cell>

                <Table.Cell>

                    <Label color='olive' basic > {item.status}</Label>

                </Table.Cell>

            </Table.Row>
        </>
    ));
   

    return (
        <div>
            {loading && (
                <Dimmer active inverted>
                    <Loader content='please wait ...' />
                </Dimmer>
            )}

            {order && (
                <Table striped stackable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>S/N</Table.HeaderCell>
                            <Table.HeaderCell>Name</Table.HeaderCell>
                            <Table.HeaderCell>Price</Table.HeaderCell>
                            <Table.HeaderCell>Discount</Table.HeaderCell>
                            <Table.HeaderCell>Date</Table.HeaderCell>
                            <Table.HeaderCell></Table.HeaderCell>

                        </Table.Row>
                    </Table.Header>

                    <Table.Body>{orderItems}</Table.Body>
                    <Table.Body>

                   
                        <Table.Row>
                            <Table.Cell>
                
                            </Table.Cell>
                            <Table.Cell>
                             <b>Total Room Amount </b>
                            </Table.Cell>
                            <Table.Cell>
                             
                             ₦{numeral(order?.filter(a => a.name === 'Room')?.reduce((acc, curr) => acc + curr?.price, 0)).format("0,0")}

                            </Table.Cell>
                            
                            <Table.Cell>
                            ₦{numeral(order?.filter((a) => a.name === 'Room')[0]?.discount).format("0,0")}

                            </Table.Cell>
                            <Table.Cell>

                            </Table.Cell>
                            <Table.Cell>

                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>
                        
                            </Table.Cell>
                            <Table.Cell>
                                <b> Total Amount</b>

                            </Table.Cell>
                            <Table.Cell>
                                ₦{numeral(totalAmount.reduce((partialSum, a) => partialSum + a, 0) - order?.filter((a) => a.name === 'Room')[0]?.discount).format("0,0")}

                            </Table.Cell>
                            <Table.Cell>

                            </Table.Cell>
                            <Table.Cell>

                            </Table.Cell>
                            <Table.Cell>

                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>


            )}



            {parseInt(totalAmount) > 0 && (<Button onClick={() => makePayment()} style={{ backgroundColor: '#26f09e', color: '#000000' }}>Make Payment and Checkout</Button>)}
            {parseInt(totalAmount.reduce((partialSum, a) => partialSum + a, 0)) === 0 && (<Button onClick={() => checkoutCustomer()} style={{ backgroundColor: '#26f09e', color: '#000000' }}>Checkout </Button>)}
            <Modal
                size="small"
                open={checkoutModalState}
                onClose={() => {
                    toggleCheckoutModal(false);
                }}
                closeIcon
            >
                <Modal.Header>Payment</Modal.Header>
                <Modal.Content>

                    <Checkout toggleModal={toggleCheckoutModal} checkout={closeModal} checked={{ bookingCode: props.booking?.bookingId, bookingId: props.booking?.id }} />
                </Modal.Content>
            </Modal>
        </div>
    )
}

export default CheckOutDetails